import React, { Component } from 'react';
import { Spin } from 'antd';
import Title from '../Components/Title';
import compareFn from '../../Components/compareFn';
import EditableCell from '../../../../basicElement/EditableCell';
import TableC from '../../../../basicElement/TableC';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';

class Comment extends Component {
    state = {
        data: [
            { total: '总计', price: '32000', siteNum: '20', period: '3' },
        ],
        prevData: [],
        loading: false,
        canEdit: false,
    }

    componentDidMount() {
        const { editable } = this.props;
        this.setState({ canEdit: editable });
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.editable && this.props.editable) {
            this.setState({ canEdit: true });
        }
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.site.queryInvestigationSiteFee)
        .then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                pagination,
                data: datas,
                loading: false,
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({ loading: false });
        });
    }

    handleAdd = () => {
        const { data } = this.state;
        data.push({ newAdd: true });
        this.setState({ data });
    }

    handleDelete = (index, record) => {
        const { data } = this.state;
        const { newAdd } = data[index];
        if (newAdd) {
            data.splice(index, 1);
        }
        this.setState({ data });
    }

    getColumns = () => {
        const { names, mode } = this.props;
        const { data, canEdit, prevData } = this.state;
        const columns = [{
            title: names.index,
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: names.commentContent,
            dataIndex: 'otherRemarks',
            key: 'otherRemarks',
            render: (text, record, index) => {
                if (mode === 'compare') {
                    return compareFn(prevData, data, 'otherRemarks');
                } else {
                    return (
                        <div className="inlineBlock">
                            <EditableCell type="Input" editable={canEdit} value={text} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'otherRemarks')} />
                        </div>
                    );
                }
            }
        }];
        if (canEdit) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 80,
                render: (text, record, index) => {
                    return <a onClick={() => this.handleDelete(index, record)}>删除</a>;
                }
            });
        }
        return columns;
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        const target = data[index];
        target[key] = value;
        this.setState({ data: [...data] });
    }

    save = (canEdit) => {
        if (!canEdit) {
            this.setState({ canEdit: true });
        } else {
            this.setState({ canEdit: false });
            // this.props.hasChange(false);
        }
    }

    render() {
        const { title, editable } = this.props;
        const { data, loading, canEdit } = this.state;
        return (
            <Spin spinning={loading}>
                <Title title={title} editable={editable} canEdit={canEdit} save={this.save} add={this.handleAdd} />
                <div style={{ paddingLeft: 10 }}>
                    <TableC
                        data={data}
                        loading={loading}
                        columns={this.getColumns()}
                        className="quotation_comment"
                    />
                </div>
            </Spin>
        );
    }
}

export default Comment;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Detail/Table/Comment.js